export default __webpack_public_path__ + "locales/ru/PeopleTranslations.json?hash=c0eed792ab95bbf9e4cdb3a1dbfc55fa";